import debug from 'debug';
import getConfig from 'next/config';

var _getConfig = getConfig(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var applicationNamespace = publicRuntimeConfig.applicationNamespace;
var DEBUG_NAMESPACE = ['jlp', applicationNamespace].filter(Boolean).join(':');
var instance = debug(DEBUG_NAMESPACE);
export var createDebugger = function createDebugger(name) {
  return instance.extend(name);
};